var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z", fill: "#6DA544" }),
    React.createElement("path", { d: "M24 9.391L43.826 24 24 38.609 4.174 24 24 9.391z", fill: "#FFDA44" }),
    React.createElement("path", { d: "M24 32.348a8.348 8.348 0 1 0 0-16.696 8.348 8.348 0 0 0 0 16.696z", fill: "#F0F0F0" }),
    React.createElement("path", { d: "M19.826 23.478c-1.452 0-2.852.221-4.171.63a8.347 8.347 0 0 0 15.181 4.68c-2.583-3.234-6.558-5.31-11.01-5.31zM32.193 25.6a8.348 8.348 0 0 0-15.864-4.894 17.22 17.22 0 0 1 3.497-.358c4.849 0 9.235 2.015 12.367 5.251z", fill: "#0052B4" })
  );
});